import clsx from 'clsx'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { ReactComponent as IconCrypto } from 'assets/icons/icon_crypto.svg'
import { i18n } from 'translate/i18n'
import useStyles from '../../Payment.style'
import { MethodProps } from './props'

export const CryptoBRL: React.FC<MethodProps<"CRYPTO">> = ({price, checked}) => {
  const classes = useStyles()
  return (
    <Box className={clsx(classes.paymentMethodLabel, checked ? classes.paymentMethodLabelChecked : undefined)}>
      <Box className={classes.paymentMethodIcon}>
        <IconCrypto />
      </Box>
      <Box className={classes.paymentMethodText}>
        <Typography variant='body2'>
          {i18n.t('authenticated.payment.steps.stepMethod.cryptoBRL')}
        </Typography>
        <Typography variant='h4' className={classes.paymentMethodTextPrice}>{price}</Typography>
      </Box>
    </Box>
  )
}
